<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h1 class="u">
      Редактировать скидку
    </h1>
    <div class="sub-nav">
      <router-link class="btn btn-default btn-sm" :to="{ name: 'discount-details', params: { id: discount.id }}">← Назад к Деталям скидки</router-link>
    </div>

    <div class="text-right">
      <a v-if="discount.id" class="red" href="#" @click.prevent="deleteDiscount">удалить скидку</a>
    </div>

    <discount-edit-form
      :discount="discount"
      @after="handleAfter"
    />

  </div>
</template>

<script>
import { getDiscount, deleteDiscount } from '@/services/discount.service'
import discountEditForm from '@/components/forms/discount/DiscountEditForm'

export default {
  name: 'discount-edit',
  components: { discountEditForm },
  data () {
    return {
      discount: {
        id: null,
        name: '',
        amount: '',
        start_date: '',
        end_date: ''
      },

      errors: {
        discount: {
          id: [],
          name: [],
          amount: [],
          start_date: [],
          end_date: []
        },
        non_field_errors: []
      }
    }
  },
  mounted () {
    if (this.$route.params.id !== undefined) {
      this.discount.id = this.$route.params.id

      getDiscount(this.discount.id).then((response) => {
        this.discount = response.data
      })
    }
  },
  methods: {
    deleteDiscount () {
      deleteDiscount(this.discount.id).then((response) => {
        this.showMsg('Скидка была удалена!', 'success', 'Успешно')
        this.$router.push({ name: 'discounts' })
        return true
      }).catch(err => {
        this.fillErrors(this.errors.discount, err.response.data)

        if (this.errors.non_field_errors[0]) {
          this.$parent.$parent.showPopupMsg(this.errors.non_field_errors[0], 'error')
        }

        return false
      })
    },
    handleAfter (success) {
      console.log(success)
    },
    showMsg (text, type, title) {
      let foundRoot = false
      let $parent = this.$parent

      while (!foundRoot) {
        console.log($parent)
        if ($parent.$parent.$parent === undefined) {
          foundRoot = true
          $parent.showPopupMsg(text, type, title)
        } else {
          $parent = $parent.$parent
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// DiscountEdit.vue?6a254976